// const Quill = require('quill');
// require('quill/dist/quill.core.css');
// require('quill/dist/quill.snow.css');

import {renderFragment} from '../helpers/react-helpers'
import {postJson, resolveRoute} from '../helpers/ajax'
import * as kb from '../kb'
import icons from '../../markons/markons'
import Icon from '../components/Icon'
import $ from 'jquery'
import type { DataTableProps} from '../components/datatable';
import {DataTable} from '../components/datatable'
import React from 'react'
import {InternalLink} from '../components/external-links'

type SendEmailWelcomeResponse = {
    recipient: {
        email: string
    }
}

type SendWelcomeEmailRequest = {
    ownerId: StringNum
}


interface CreateCompanyPageProps {
    companyId: StringNum
    ownerId: StringNum
}

export default function CreateCompanyPage({companyId, ownerId}: CreateCompanyPageProps) {

    const companyAliasesTableConfig: DataTableProps = {
        ajax: {
            url: resolveRoute('companyAliasesDT', {companyId})
        },
        rowLink: row => resolveRoute('company_aliases.edit', {company_id: companyId, alias_id: row.id}),
        columns: [
            {
                title: "Name",
                data: 'name',
                render: ({data, row}) => (
                    <span className="ellipsis">{data}</span>
                )
            },
            {
                title: "Action",
                render: ({data, row}) => (
                    <div className="dt-btn-group">
                        <InternalLink route="company_aliases.edit" params={{company_id: companyId, alias_id: row.id}}
                           className="btn btn-edit no-margin"><i className="mrkn fa-pencil"></i> Edit</InternalLink>
                    </div>
                ),
                width: '75px',
                orderable: false,
            },
            {
                title: "Active",
                data: 'active',
                className: 'tcenter',
                width: '75px',
                render: ({data, row}) => (
                    <span>
                        <Icon name={data ? icons.faCheckCircle : icons.faTimesCircle}
                              color={data ? '#1B9E1C' : '#D7362C'}/>
                   </span>
                )
            }
        ],
        order: [['name', 'asc']]
    }

    renderFragment(<DataTable {...companyAliasesTableConfig} />, '#company-aliases-table')

    const $sendWelcomeEmailBtn = $('#send-welcome-email')
    $sendWelcomeEmailBtn.on('click', (event: Event) => {
        event.preventDefault()
        $sendWelcomeEmailBtn.prop('disabled', true)

        postJson<SendEmailWelcomeResponse, SendWelcomeEmailRequest>(resolveRoute('api.send_welcome_email', {'id': companyId}), {ownerId})
            .then(res => {
                if(res.ok) {
                    kb.notify({
                        html: `Login details sent to ${res.data.recipient.email}`,
                        className: "success",
                    })
                } else {
                    kb.notify({
                        html: "Server error. This service may be down or broken at moment; please bear with us while we get it working again!",
                        className: "error",
                    })
                }
            })
            .catch(() => {
                kb.notify({
                    html: "A network error occurred. Please try a few more times!",
                    className: "error",
                })
            })
            .finally(() => {
                $sendWelcomeEmailBtn.prop('disabled', false)
            })
    })
}

